import { diccionarioDe, type Idioma } from '../../../i18n/index.js';

/** Cuántas se pintan como mucho. Si el modelo manda más, sobran; no es motivo para tirar nada. */
const CUANTAS = 3;

/**
 * Tres formas de seguir preguntando. Las pone el motor con lo que el modelo sugirió.
 *
 * **El recorte se hace aquí, al pintar, y no en el esquema.** El esquema exigía exactamente tres
 * de 160 caracteres como mucho, así que una sugerencia larga o una cuarta **mataban la respuesta
 * entera**, ya pagada. Son el adorno del pie: si vienen cinco, se enseñan tres.
 */
export function Sugerencias({ sugerencias, idioma }: { readonly sugerencias: readonly string[]; readonly idioma: Idioma }) {
  if (sugerencias.length === 0) return null;
  const t = diccionarioDe(idioma).consulta;
  const aPintar = sugerencias.slice(0, CUANTAS);

  return (
    <nav className='mt-6' aria-label={t.sigueP}>
      <p className='m-0 mb-2 font-(family-name:--text) text-[13px] text-(--ink-faint)'>{t.sigueP}:</p>
      <ul className='m-0 flex list-none flex-col gap-2 p-0'>
        {aPintar.map(s => (
          <li key={s}>
            <a href={`/preguntar?q=${encodeURIComponent(s)}`} className='font-(family-name:--text) text-[15px] text-(--teal-deep)'>
              {s}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
